import { FloorGuideType } from '@/enums/floor-guide';
import { useMemo } from 'react';

export const PATHS = {
    INDEX: '/',
    HOME: {
        INDEX: '/home',
    },
    FLOOR_GUIDE: {
        INDEX: '/floor-guide',
        CURRENT_LOCATION: (studioFloorID: string, studioPoiId: string) =>
            `/floor-guide?studioFloorID=${studioFloorID}&studioPoiId=${studioPoiId}&floorGuideType=${FloorGuideType.MARKER}`,
        DIRECTION_GUIDE: (studioFloorID: string, studioPoiId: string) =>
            `/floor-guide?studioFloorID=${studioFloorID}&studioPoiId=${studioPoiId}&floorGuideType=${FloorGuideType.DIRECTION}`,
        DIRECTION_GUIDE_FROM_PARKING: (title: string, floorId: string) =>
            `/floor-guide?title=${title}&floorId=${floorId}&floorGuideType=${FloorGuideType.DIRECTION}`,
    },
    SHOP: {
        INDEX: '/shop',
    },
    CUSTOM_MENU: {
        LIST_TYPE: '/custom-menu/list-type',
        LIST_TYPE_DETAIL: (gnbMenuId: string, id: string) =>
            `/custom-menu/list-type/${gnbMenuId}/detail/${id}`,
        CARD_TYPE: '/custom-menu/card-type',
        TOGGLE_TYPE: '/custom-menu/toggle-type',
        CATEGORY_TYPE: '/custom-menu/category-type'
    },
    ERRORS: {
        INDEX: '/errors',
        404: '/errors/404',
        500: '/errors/500',
    },
};

export interface Route {
    name: string;
    path?: string;
    pathName?: string;
    active?: boolean;
    pages?: Route[];
}

export function useRoutes(): Route[] {
    return useMemo(() => {
        return [
            { name: '홈', path: PATHS.HOME.INDEX, pathName: '/home/HomePage.tsx', active: true },
            { name: '층별안내', path: PATHS.FLOOR_GUIDE.INDEX, pathName: '/floor-guide/FloorGuidePage.tsx', active: true },
            { name: '매장검색', path: PATHS.SHOP.INDEX, pathName: '/shop/ShopPage.tsx', active: true },
            { name: 'list type', path: PATHS.CUSTOM_MENU.LIST_TYPE, pathName: '/custom-menu/list-type/ListTypePage.tsx', active: true },
            { name: 'card type', path: PATHS.CUSTOM_MENU.CARD_TYPE, pathName: '/custom-menu/card-type/CardTypePage.tsx', active: true },
            { name: 'toggle type', path: PATHS.CUSTOM_MENU.TOGGLE_TYPE, pathName: '/custom-menu/toggle-type/ToggleTypePage.tsx', active: true },
            { name: 'category type', path: PATHS.CUSTOM_MENU.CATEGORY_TYPE, pathName: '/custom-menu/category-type/CategoryTypePage.tsx', active: true },
            {
                name: 'errors',
                path: PATHS.ERRORS.INDEX,
                active: false,
                pages: [
                    {
                        name: '404',
                        active: true,
                        path: PATHS.ERRORS[404],
                        pathName: 'errors/Error404.tsx',
                    },
                    {
                        name: '500',
                        active: true,
                        path: PATHS.ERRORS[500],
                        pathName: 'errors/Error500.tsx',
                    },
                ],
            },
        ];
    }, []);
}
